export const ApiUrl = import.meta.env.VITE_API_URL || '';

export const ApiHost = {
  BackendService: ApiUrl,
  // Add more service hosts as needed:
  // CampaignService: ApiUrl + '/api/campaign-service',
  // ReportingService: ApiUrl + '/api/reporting-service',
  // FileService: ApiUrl + '/api/file-service',
  // AuthService: ApiUrl + '/api/rbac-service',
} as const;
